import React from "react";

export const PublicOpinion = React.lazy(
  () => import("@/features/public-opinion/pages/PublicOpinionPage.tsx"),
);
